// @flow
import type { Action, Config } from '../types';
import initialState from '../../server/shared/configInitialState';
import * as constants from '../constants/configConstants';

export type State = $ReadOnly<{
    data: Config,
    status: $ReadOnly<{
        fetched: boolean,
        isLoading: boolean,
        error: boolean
    }>
}>;

export default function config(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.LOAD_CONFIG: {
            const data = {};

            for(let i = 0, length = action.data.length; i < length; i += 1) {
                let _item = action.data[i];
                const id = _item.id;

                let item = {
                    ...state.data[id],
                    ..._item
                };

                if(id === 'map') {
                    item = {
                        ...item,
                        sources: {
                            ..._item.sources,
                            ...state.data[id].sources
                        }
                    };
                }

                delete item.id;

                data[id] = item;
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    ...data
                },
                status: {
                    ...state.status,
                    fetched: true
                }
            };
        }

        case constants.SET_CONFIG: {
            const id = action.data.id;
            const data = {
                ...action.data
            };
            delete data.id;

            const config = state.data[id];

            return {
                ...state,
                data: {
                    ...state.data,
                    [id]: {
                        ...config,
                        ...data
                    }
                }
            };
        }

        case constants.UNSET_CONFIG: {
            const id = action.data.id;
            const data = {
                ...state.data
            };
            delete data[id];

            return {
                ...state,
                data
            };
        }

        case constants.PREVIEW_MAP_SOURCE: {
            return {
                ...state,
                data: {
                    ...state.data,
                    map: {
                        ...state.data.map,
                        previewSource: action.data
                    }
                }
            };
        }

        default:
            return state;
    }
}